<!doctype html>
<html lang="en">

<head>
  <!-- Required meta tags -->
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">

  <!-- Bootstrap CSS -->
  <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css"
    integrity="sha384-Vkoo8x4CGsO3+Hhxv8T/Q5PaXtkKtu6ug5TOeNV6gBiFeWPGFN9MuhOf23Q9Ifjh" crossorigin="anonymous">
</head>

<body>


  <div class="container-fluid">
    <div class="row">
      <div class="col-md-6 labeldetail">
        <form>
          <fieldset>
            <legend>Name&Address</legend>
            <div class="form-group ">
              <label >Name:</label>
              <input type="text" name="input1" [(ngModel)]="details.name">
            </div>
            <div class="form-group ">
              <label >Code:</label>
              <input type="text"  name="input2" [(ngModel)]="details.code">
            </div>
            <div class="form-group ">
              <label >Address1:</label>
              <input type="text" name="input3" [(ngModel)]="details.address1">
            </div>
            <div class="form-group ">
              <label >Address2:</label>
              <input type="text"  name="input4" [(ngModel)]="details.address2">
            </div>
            <div class="form-group ">
              <label >City:</label>
              <input type="text"  name="input5" [(ngModel)]="details.city">
            </div>
            <div class="form-group ">
              <label >State:</label>
              <select  name="states" aria-label="Default select example" [(ngModel)]="details.stateID">
                <option selected disabled>- Select State -</option>
                <option *ngFor="let ds of dwStates" [ngValue]="ds.id">{{ds.name}}</option>
              </select>
            </div>
            <div class="form-group ">
              <label >Postal Code:</label>
              <input type="text"  name="input7" [(ngModel)]="details.postalCode">
            </div>
          </fieldset>
        </form>
      </div>
      <div class="col-md-6 labeldetail">
        <form>
        <fieldset>
          <legend>Other Details</legend>

          <div class="form-group">
            <label >Email:</label>
            <input type="email"  name="input8" [(ngModel)]="details.email">
          </div>
          <div class="form-group">
            <label >Main Number:</label>
            <input type="text"  name="input9" [(ngModel)]="details.mainNumber">
          </div>
          <div class="form-group">
            <label >Secondary Number:</label>
            <input type="text"  name="input10" [(ngModel)]="details.secondaryNumber">
          </div>
          <div class="form-group">
            <label>Fax Number:</label>
            <input type="text"  name="input11" [(ngModel)]="details.faxNumber">
          </div>
          <div class="form-group">
            <label >URL:</label>
            <input type="email"  name="input12" [(ngModel)]="details.url">
          </div>
          <div class="form-group ">
            <label >Notes:</label>
            <textarea name="notes" rows="5" cols="50" [(ngModel)]="details.notes"></textarea>

          </div>

        </fieldset>
        </form>
      </div>
      <div *ngIf="isLoading" class="spinner-wrapper">
        <mat-spinner diameter="32" color="primary"></mat-spinner>
      </div>
    
    </div>
    <br>
    <div class="row"
      *ngIf="dynamicTabService.selectedTabData && dynamicTabService.selectedTabData.label == label && dynamicTabService.selectedTabData.type == 'association'">
      <mat-tab-group animationDuration="0ms">
        <!-- Master Policies tab -->
        <mat-tab label="Master Policies">
          <div>
            <h5 class="card-title">Master Policies</h5>

              <nav class="navbar navbar-light bg-light justify-content-between">
                <a class="navbar-brand col-md-2"
                  (click)="createTabsFromNavbarData({routerLink: 'policyAddNew',label: 'Add New',id:'-10'})"><i
                    class="fa fa-plus "></i></a>
                <div class="input-group search-style col-md-2">
                  <input class="form-control mr-sm-1" type="search" [(ngModel)]="searchTerm"
                    placeholder="Search">
                  <div class="input-group-append ">
                    <button class="btn removefocus" type="button" (click)="search()" *ngIf="!isSearching">
                      <i class="fa fa-search"></i>
                    </button>
                    <button class="btn removefocus" type="button" (click)="clearSearch()" *ngIf="isSearching">
                      <i class="fa fa-times"></i>
                    </button>

                  </div>
                </div>
              </nav>


              <section class="table-container " tabindex="0">
                <table mat-table [dataSource]="dataSource" class="table table-bordered">

                  <ng-container matColumnDef="policyNumber">
                    <th mat-header-cell *matHeaderCellDef>
                      <button class="btn btn-link" matTooltip="Policy Number is not sortable">
                        Policy Number
                      </button>
                    </th>
                    <td mat-cell *matCellDef="let policy">
                      <a (click)="openPolicy(policy)">
                        {{policy.policyNumber}}
                      </a>

                    </td>
                    <!-- <a (click)="sendIdtochild(policy.id)">{{policy.policyNumber}}</a></td> -->
                  </ng-container>
                  <ng-container matColumnDef="policyType">
                    <th mat-header-cell *matHeaderCellDef>
                      <button class="btn btn-link" (click)="sortData('policyType')" matTooltip="Sort by Policy Type">
                        Policy Type
                        <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='policyType'"
                          [class.fa-sort-asc]="sortingColumn ==='policyType' && sortOrder === 'asc'"
                          [class.fa-sort-desc]="sortingColumn ==='policyType' && sortOrder === 'desc'"></i>
                      </button>
                    </th>
                    <td mat-cell *matCellDef="let policy">{{ policy.policyType}}</td>
                  </ng-container>
                  <ng-container matColumnDef="contractNumber">
                    <th mat-header-cell *matHeaderCellDef>
                      <button class="btn btn-link" (click)="sortData('contractNumber')" matTooltip="Sort by Contract">
                        Contract
                        <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='contractNumber'"
                          [class.fa-sort-asc]="sortingColumn ==='contractNumber' && sortOrder === 'asc'"
                          [class.fa-sort-desc]="sortingColumn ==='contractNumber' && sortOrder === 'desc'"></i>
                      </button>
                    </th>
                    <td mat-cell *matCellDef="let policy">{{ policy.contractNumber}}</td>
                  </ng-container>
                  <ng-container matColumnDef="policyStatus">
                    <th mat-header-cell *matHeaderCellDef>
                      <button class="btn btn-link" (click)="sortData('policyStatus')"
                        matTooltip="Sort by Policy Status">
                        Policy Status
                        <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='policyStatus'"
                          [class.fa-sort-asc]="sortingColumn ==='policyStatus' && sortOrder === 'asc'"
                          [class.fa-sort-desc]="sortingColumn ==='policyStatus' && sortOrder === 'desc'"></i>
                      </button>
                    </th>
                    <td mat-cell *matCellDef="let policy">{{ policy.policyStatus}}</td>
                  </ng-container>

                  <ng-container matColumnDef="effectiveDate">
                    <th mat-header-cell *matHeaderCellDef>
                      <button class="btn btn-link" (click)="sortData('effectiveDate')"
                        matTooltip="Sort by Effective Date">
                        Effective Date
                        <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='effectiveDate'"
                          [class.fa-sort-asc]="sortingColumn ==='effectiveDate' && sortOrder === 'asc'"
                          [class.fa-sort-desc]="sortingColumn ==='effectiveDate' && sortOrder === 'desc'"></i>
                      </button>
                    </th>
                    <td mat-cell *matCellDef="let policy">{{ policy.effectiveDate| date:'MM/dd/yyyy'}}</td>
                  </ng-container>
                  <ng-container matColumnDef="expirationDate">
                    <th mat-header-cell *matHeaderCellDef>
                      <button class="btn btn-link" (click)="sortData('expirationDate')"
                        matTooltip="Sort by Expiration Date">
                        Expiration Date
                        <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='expirationDate'"
                          [class.fa-sort-asc]="sortingColumn ==='expirationDate' && sortOrder === 'asc'"
                          [class.fa-sort-desc]="sortingColumn ==='expirationDate' && sortOrder === 'desc'"></i>
                      </button>
                    </th>
                    <td mat-cell *matCellDef="let policy">{{ policy.expirationDate | date:'MM/dd/yyyy'}}</td>
                  </ng-container>
                  <ng-container matColumnDef="premium">
                    <th mat-header-cell *matHeaderCellDef>
                      <button class="btn btn-link" (click)="sortData('premium')" matTooltip="Sort by Premium">
                        Premium
                        <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='premium'"
                          [class.fa-sort-asc]="sortingColumn ==='premium' && sortOrder === 'asc'"
                          [class.fa-sort-desc]="sortingColumn ==='premium' && sortOrder === 'desc'"></i>
                      </button>
                    </th>
                    <td mat-cell *matCellDef="let policy">{{ policy.premium }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="notes">
                    <th mat-header-cell *matHeaderCellDef>
                      <button class="btn btn-link" (click)="sortData('notes')" matTooltip="Sort by Notes">
                        Notes
                        <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='notes'"
                          [class.fa-sort-asc]="sortingColumn ==='notes' && sortOrder === 'asc'"
                          [class.fa-sort-desc]="sortingColumn ==='notes' && sortOrder === 'desc'"></i>
                      </button>
                    </th>
                    <td mat-cell *matCellDef="let policy">{{ policy.notes}}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="created">
                    <th mat-header-cell *matHeaderCellDef>
                      <button class="btn btn-link" (click)="sortData('created')" matTooltip="Sort by Created">
                        Created
                        <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='created'"
                          [class.fa-sort-asc]="sortingColumn ==='created' && sortOrder === 'asc'"
                          [class.fa-sort-desc]="sortingColumn ==='created' && sortOrder === 'desc'"></i>
                      </button>
                    </th>
                    <td mat-cell *matCellDef="let policy">{{ policy.created}}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="createdBy">
                    <th mat-header-cell *matHeaderCellDef>
                      <button class="btn btn-link" matTooltip="Created By User is not sortable">
                      </button>Created  By User
                    </th>
                    <td mat-cell *matCellDef="let policy">{{ policy.createdBy}}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="lastUpdated">
                    <th mat-header-cell *matHeaderCellDef>
                      <button class="btn btn-link" (click)="sortData('lastUpdated')" matTooltip="Sort by Last Updated">
                        Last Updated
                        <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='lastUpdated'"
                          [class.fa-sort-asc]="sortingColumn ==='lastUpdated' && sortOrder === 'asc'"
                          [class.fa-sort-desc]="sortingColumn ==='lastUpdated' && sortOrder === 'desc'"></i>
                      </button>
                    </th>
                    <td mat-cell *matCellDef="let policy">{{ policy.lastUpdated}}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="lastUpdatedBy">
                    <th mat-header-cell *matHeaderCellDef>
                      <button class="btn btn-link" matTooltip=" Last Updated By User is not sortable">
                        Last Updated By User
                      </button>
                    </th>
                    <td mat-cell *matCellDef="let policy">{{ policy.lastUpdatedBy}}
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="columnsToDisplay;sticky: true" class="headerstyle"></tr>
                  <tr mat-row *matRowDef="let policy; columns: columnsToDisplay"></tr>
                </table>
              </section>
              <!--Pagination-->
              
                <div>
                  <mat-paginator class="pagination" [length]="totalItems" [hidePageSize]="isHidePageSize"
                  [showFirstLastButtons]="showFirstLastButtons" (page)="onPageChange($event)" aria-label="Select page">
                  </mat-paginator>
                </div>
            
            
            <!-- Table spinner -->
            <div *ngIf="isLoading" class="spinner-wrapper">
              <mat-spinner diameter="32" color="primary"></mat-spinner>
            </div>
          </div>
        </mat-tab>
        <!-- Application Settings tab -->
        <mat-tab label="Application Settings">

          <div class="applicationTab1">
              <fieldset class="col-md-12 ">
                <legend>Check Mailing Info</legend>

                <label for="input13">Check Mailing Name:</label>
                <input type="text"  id="input13" name="input13" [(ngModel)]="details.checkMailingName">

                <label for="input14">Check Mailing Address Line1:</label>
                <input type="text" id="input14" name="input14"
                  [(ngModel)]="details.checkMailingAddressLine1">

                <label for="input15">Check Mailing Address Line2:</label>
                <input type="text" id="input15" name="input15"
                  [(ngModel)]="details.checkMailingAddressLine2">


              </fieldset>
            </div>
            <div class="applicationTab2">
              <fieldset class="col-md-12">
                <legend>Disclaimers</legend>
                <div class="form-group">
                  <label for="input13">Hunt Lease Application:</label>
                  <textarea id="notes" rows="5" name="notes"
                    [(ngModel)]="details.huntLeaseDisclaimer"></textarea><br>
                </div>
                <div class="form-group">
                  <label for="input14">Timberland Application:</label>
                  <textarea  id="notes" rows="5" name="notes"
                    [(ngModel)]="details.timberlandDisclaimer"></textarea>
                </div>
              </fieldset>
            </div>
           
       
        </mat-tab>
        <!-- Membership Fees setup tab-->
        <mat-tab label=" Membership Fees Setup">

          <div class="col-md-8 labelmember">
            <p style="font-size:12px">
              *Hover over each textbox for more details
            </p>

            <label for="input15">Membership Verification Email To:</label>
            <input type="text" id="input15" name="input15" [(ngModel)]="details.membershipVerificationEmailTo"
              title="Specifies where to send emails when a Member Policy application is received and the applicant specifies that they have an active membership">



            <label for="input16">Membership Fees Collected Email To:</label>
            <input type="text" id="input16" name="input16" [(ngModel)]="details.membershipFeesCollectedEmailTo"
              title="Specifies where to send emails when a Member Policy is activated and membership fees were collected">

            <label for="input17">Membership Benefits Link:</label>
            <input type="text" id="input17" name="input17" [(ngModel)]="details.memberBenefitsURL">

            <label for="input18">Hunt Club Membership Fee:</label>
            <input type="string" id="input18" name="input18" [(ngModel)]="details.huntClubMembershipFee">

            <label for="customCheck1">Hunt Club Membership Fee Custom: </label>
            <input type="checkbox" value="" id="customCheck1" name="customCheck1"
              [(ngModel)]="details.huntClubMembershipFeeCustom"><br>

            <label for="input18">Hunt Club Membership Fee Script:</label>
            <input type="text" id="input18" name="input18" [(ngModel)]="details.huntClubMembershipFeeScript">

            <label for="input18">Landowner Membership Fee:</label>
            <input type="string" id="input19" name="input19" [(ngModel)]="details.landownerMembershipFee">

            <label for="customCheck2">Landowner Membership Fee Custom: </label>
            <input type="checkbox" value="customCheck2" id="customCheck2" name="customCheck2"
              [(ngModel)]="details.landownerMembershipFeeCustom"><br>

            <label for="input19">Landowner Membership Fee Script:</label>
            <textarea type="text" id="input20" rows="3" name="input20" style="width:40%"
              [(ngModel)]="details.landownerMembershipFeeScript"></textarea>
          </div>

        </mat-tab>
        <!-- Other Ins Portal Settings -->
        <mat-tab label="Other Ins Portal Settings">
          <div class="otherTab">

            <p style="font-size:12px"> On the Insurance Portal,display info for these products:</p>

            <label for="customCheck3">Display Standing Timber Info:</label>
            <input type="checkbox" value="" id="customCheck3" name="customCheck3"
              [(ngModel)]="details.displayStandingTimberInfo"><br>

            <label for="customCheck4"> Display Prescribed Burning Info: </label>
            <input type="checkbox" value="" id="customCheck4" name="customCheck4"
              [(ngModel)]="details.displayPrescribedBuringInfo"><br>

            <label for="customCheck5">Display Timberland Fire Coverage Info:</label>
            <input type="checkbox" value="" id="customCheck5" name="customCheck5"
              [(ngModel)]="details.displayTimberlandFireCoverageInfo"><br>
          </div>
        </mat-tab>
        <!-- Quick Quote Setup -->
        <mat-tab label="Quick Quote Setup">
       <div class="quickTab">
              <label for="customCheck6">Available To Quick Quote: </label>
              <input type="checkbox" value="" id="customCheck6" name="customCheck5"
                [(ngModel)]="details.availableToQuickQuote"><br>
         
              <label for="input16">Available States:</label>
              <input type="text" id="input16" name="input16" [(ngModel)]="details.availableStates">
            <br><br>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</body>

</html>